import React, { Component } from 'react';

import '../css/erasersmenu.css'
import { ITeamDrawingSizes, ITeamModes, iteamWorkingModeInstance } from '../datamodel/datamodel';


class IteamChooseEraserMenuComponent extends Component {
    constructor(props) {
        super(props);

        this.state = {
            currentEraserSize: iteamWorkingModeInstance.getDrawingSizeOfMode(ITeamModes.eraser)
        };

        this.chooseEraserMenu = React.createRef();
    }

    componentDidMount() {
        let componentHeight = this.chooseEraserMenu.current.offsetHeight;
        let chooseEraserBtnTop = this.props.chooseEraserBtnTop;
        let chooseEraserBtnHeight = this.props.chooseEraserBtnHeight;
        let componentTop = Math.round(chooseEraserBtnTop - componentHeight / 2 + chooseEraserBtnHeight / 2);
        this.chooseEraserMenu.current.style.top = `${componentTop}px`;

        iteamWorkingModeInstance.setMode(ITeamModes.eraser);

    }
    
    chooseEraserItemClickHandler(drawingSize) {
        if (drawingSize === 'eraseall') {
            iteamWorkingModeInstance.eraseAllDrawings();
            this.props.showChooseEraserMenu();
            return;
        }
        this.setState({currentEraserSize: drawingSize});
        iteamWorkingModeInstance.setDrawingSize(drawingSize);
        this.props.showChooseEraserMenu();
    }

    render() {''
        return (<div className='iteamEraserChooseMenu' ref={this.chooseEraserMenu}>
            <div className='iteamEraserChooseMenuBlend'></div>
            <div className='iteamEraserChooseMenuRow'>
                <div className='iteamEraserChooseMenuCol'>
                    <button className='iteamEraserChooseMenuButton'
                        onPointerDown={event => event.stopPropagation()}
                        onPointerUp={event => {event.stopPropagation(); this.chooseEraserItemClickHandler(ITeamDrawingSizes.small)}}
                        onClick={event => {event.stopPropagation(); this.chooseEraserItemClickHandler(ITeamDrawingSizes.small)}}>
                            {iteamWorkingModeInstance.getDrawingSizeOfMode(ITeamModes.eraser) === ITeamDrawingSizes.small ? <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 200"><path d="M100,60a40,40,0,1,0,40,40A40,40,0,0,0,100,60Zm21.5,27.63-20.37,32.89A5.78,5.78,0,0,1,97,123.19a4.59,4.59,0,0,1-4.59-1.14l-.33-.33a5.94,5.94,0,0,1-1.37-1.37L78.61,108.18a4.62,4.62,0,0,1,0-6.5l2.33-2.33a4.59,4.59,0,0,1,6.49,0l7.49,7.51,16-25.82a5.8,5.8,0,0,1,8-1.87l.75.47A5.83,5.83,0,0,1,121.5,87.63Z"/></svg> : <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 200"><circle cx="100" cy="100" r="40"/></svg>}
                    </button>
                </div>
                <div className='iteamEraserChooseMenuCol'>
                    <button className='iteamEraserChooseMenuButton'
                        onPointerDown={event => event.stopPropagation()}
                        onPointerUp={event => {event.stopPropagation(); this.chooseEraserItemClickHandler(ITeamDrawingSizes.medium)}}                    
                        onClick={event => {event.stopPropagation(); this.chooseEraserItemClickHandler(ITeamDrawingSizes.medium)}}>
                            {iteamWorkingModeInstance.getDrawingSizeOfMode(ITeamModes.eraser) === ITeamDrawingSizes.medium ? <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 200"><path d="M100,37.5A62.5,62.5,0,1,0,162.5,100,62.5,62.5,0,0,0,100,37.5Zm33.59,43.17-31.82,51.39a9,9,0,0,1-6.39,4.17,7.2,7.2,0,0,1-7.18-1.77l-.52-.53a8.83,8.83,0,0,1-2.13-2.14l-19-19a7.21,7.21,0,0,1,0-10.16L70.22,99a7.18,7.18,0,0,1,10.13,0l11.72,11.75,25-40.35a9,9,0,0,1,12.44-2.92l1.19.73A9.11,9.11,0,0,1,133.59,80.67Z"/></svg> : <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 200"><circle cx="100" cy="100" r="62.5"/></svg>}
                    </button>
                </div>
                <div className='iteamEraserChooseMenuCol'>
                    <button className='iteamEraserChooseMenuButton'
                        onPointerDown={event => event.stopPropagation()}
                        onPointerUp={event => {event.stopPropagation(); this.chooseEraserItemClickHandler(ITeamDrawingSizes.large)}}                    
                        onClick={event => {event.stopPropagation(); this.chooseEraserItemClickHandler(ITeamDrawingSizes.large)}}>
                            {iteamWorkingModeInstance.getDrawingSizeOfMode(ITeamModes.eraser) === ITeamDrawingSizes.large ? <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 200"><path d="M100,15a85,85,0,1,0,85,85A85,85,0,0,0,100,15Zm45.68,58.71L102.41,143.6a12.29,12.29,0,0,1-8.69,5.68A9.75,9.75,0,0,1,84,146.86l-.71-.71a12.32,12.32,0,0,1-2.9-2.91L54.56,117.39a9.82,9.82,0,0,1,0-13.82l4.93-4.95a9.77,9.77,0,0,1,13.79,0l15.93,16,34-54.88a12.33,12.33,0,0,1,16.93-4l1.61,1A12.38,12.38,0,0,1,145.68,73.71Z"/></svg> : <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 200"><circle cx="100" cy="100" r="85"/></svg>}
                    </button>
                </div>
                <div className='iteamEraserChooseMenuCol'>
                    <button className='iteamEraserChooseMenuButton'
                        onPointerDown={event => event.stopPropagation()}
                        onPointerUp={event => {event.stopPropagation(); this.chooseEraserItemClickHandler('eraseall')}}                    
                        onClick={event => {event.stopPropagation(); this.chooseEraserItemClickHandler('eraseall')}}>
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 200"><path d="M24.08,55.21H175.92l-5.13-14.76a26.75,26.75,0,0,0-25.26-18H54.47a26.75,26.75,0,0,0-25.26,18Z"/><path d="M130.8,45H69.2V11.17A11.18,11.18,0,0,1,80.37,0h39.26A11.18,11.18,0,0,1,130.8,11.17ZM79.09,35.12h41.82V11.17a1.28,1.28,0,0,0-1.28-1.28H80.37a1.28,1.28,0,0,0-1.28,1.28Z"/><path d="M33.38,65.28l8.77,115a21,21,0,0,0,21,19.72h73.74a21,21,0,0,0,21-19.72l8.77-115ZM70.21,175.12a5.12,5.12,0,0,1-5.12,5.12h0A5.12,5.12,0,0,1,60,175.12V87.85a5.12,5.12,0,0,1,5.12-5.12h0a5.12,5.12,0,0,1,5.12,5.12Zm34.91,0a5.12,5.12,0,0,1-5.12,5.12h0a5.12,5.12,0,0,1-5.12-5.12V87.85A5.12,5.12,0,0,1,100,82.73h0a5.12,5.12,0,0,1,5.12,5.12Zm34.91,0a5.12,5.12,0,0,1-5.12,5.12h0a5.12,5.12,0,0,1-5.12-5.12V87.85a5.12,5.12,0,0,1,5.12-5.12h0A5.12,5.12,0,0,1,140,87.85Z"/></svg>
                    </button>
                </div>
            </div>
        </div>);
    }
}

export default IteamChooseEraserMenuComponent;